import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-terapia-intensiva',
  templateUrl: './terapia-intensiva.component.html',
  styleUrls: ['./terapia-intensiva.component.css']
})
export class TerapiaIntensivaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
